<template>
  <section class="hero-branding bg-cover" :style="dark" id="home">
    <div class="container-fluid container-fluid--cp-150">
      <div class="row hero-startup">
        <div class="col-md-6">
          <div class="hero-content">
            <h2 class="h1 hero-content-title">Pixel is bringing gamification to NFTs and Defi.</h2>
            <h6 class="hero-content-subtitle mt-20">
              Not all NFTs are created equal. Pixel is producing gamified NFT drops and
              play-for-reward games on the Tezos blockchain. Reach out if you'd like to make your
              next project <i>pixel-powered!</i>
            </h6>
            <div class="slider-button mt-30">
              <a href="#projects" class="scroll btn btn--green">See Our Projects</a>
              <h6 class="sub-heading">
                or
                <a href="#contact" class="hover-style-link hover-style-link--green">Contact Us</a>
              </h6>
            </div>
          </div>
        </div>
        <div class="col-md-6 align-self-end d-none d-md-block">
          <div class="startup-thumb">
            <img src="../assets/img/hero/startup/top.png" class="img-fluid" alt="startup-thumb" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dark: {
        backgroundImage: `url(${require('../assets/img/hero/startup/layer0.png')})`,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variabls.scss';
@import '../assets/scss/elements/hero-branding.scss';

.hero-branding {
  // responsive
  @media #{$large-mobile} {
    height: 950px;
  }
}
.hero-startup {
  align-items: center;
  display: flex;
  height: 100vh;
  .startup-thumb {
    bottom: -32px;
    position: relative;
    z-index: 1;
    // responsive
    @media #{$tablet-device} {
      bottom: -15px;
    }
  }
}
.hero-content {
  // responsive
  @media #{$tablet-device} {
    width: 100%;
  }
  &-title,
  &-subtitle {
    color: $white;
  }
  .slider-button {
    display: flex;
    align-items: center;
    // responsive
    @media #{$tablet-device, $extra-small-mobile} {
      display: block;
    }
  }
  .sub-heading {
    font-size: 15px;
    color: $white;
    padding-left: 20px;
    // responsive
    @media #{$tablet-device, $extra-small-mobile} {
      padding-left: 0;
      padding-top: 15px;
    }
  }
}
</style>
